import React from "react";
import { createSvgIconComponent } from "../";

export const IconToolTip = createSvgIconComponent({
  viewBox: "0 0 20 20",
  paths: [
    {
      d: "M18 10a8 8 0 0 1-8 8v4c6.627 0 12-5.373 12-12h-4Zm-8 8a8 8 0 0 1-8-8h-4c0 6.627 5.373 12 12 12v-4Zm-8-8a8 8 0 0 1 8-8v-4C3.373-2-2 3.373-2 10h4Zm8-8a8 8 0 0 1 8 8h4c0-6.627-5.373-12-12-12v4Z",
      props: {
        mask: "url(#icon-tooltip-mask)",
      },
    },
    {
      d: "M11.047 6.062c0 .586-.448 1.061-1 1.061s-1-.475-1-1.061c0-.587.448-1.062 1-1.062s1 .475 1 1.062ZM9.047 9.624c0-.587.448-1.062 1-1.062s1 .475 1 1.062v3.965c0 .587-.448 1.062-1 1.062s-1-.475-1-1.062V9.624Z",
    },
  ],
  children: (
    <>
      <mask id="icon-tooltip-mask" fill="white">
        <path d="M20 10c0 5.523-4.477 10-10 10S0 15.523 0 10 4.477 0 10 0s10 4.477 10 10Z" />
      </mask>
    </>
  ),
});
